import React from 'react';
import { useStyles } from './VerticalLinearProgressCartoon.styles';
export var VerticalLinearProgressCartoon = function (_a) {
    var progress = _a.progress;
    var classes = useStyles();
    var progressLevel = !progress ? 5 : progress > 100 ? 100 : progress;
    return (React.createElement("div", { className: classes.wrapper },
        React.createElement("div", { className: classes.progress, style: { height: "".concat(progressLevel, "%") } })));
};
